import Call from '../Call';
import {objToQs} from '../Utils';

const PayoutCountryFactor = {
    get(filters) {
        return Call(`payoutCountryFactor?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`payoutCountryFactor/affid`);
    },
}

export default PayoutCountryFactor;



// WEBPACK FOOTER //
// ./src/services/API/components/PayoutCountryFactor.js